<div class="c-autocomplete">
	<input type="text"
         class="c-form__input c-form__input--with-button"
         [ngClass]="{'c-form__input--sm': vm.isSmall}"
         id={{vm.id}}
         name="{{vm.id}}"
         [(ngModel)]="vm.term"
         (focus)="vm.handleInputFocus()"
         (blur)="vm.handleInputBlur(true)"
         (keydown)="vm.handleInputKeydown($event)"
         (ngModelChange)="vm.handleInputChange()"
         [attr.required]="vm.isRequired ? true : null"
         [disabled]="vm.disabled"
         autocomplete="off">
	<button type="button" class="c-form__input-btn" (click)="vm.handleInputReset()" *ngIf="vm.term && !vm.disabled">
		<i class="o-icon o-icon--x" aria-hidden="true"></i>
		<span class="u-sr-only">{{ 'Common.Cancel' | translate }}</span>
	</button>
	<ul class="c-autocomplete__list" *ngIf="vm.isActive" style="max-height: 250px;overflow-y:auto;overflow-x:hidden;z-index:10000">
		<li class="c-autocomplete__item" id="autoCompleteItem{{$index}}" *ngFor="let item of vm.items ; let $index=index" (mousedown)="vm.handleItemSelect(item)" (mouseover)="vm.handleItemActive(item)" (mouseout)="vm.handleItemsInactive()" [ngClass]="{'c-autocomplete__item--active': item.active}" tabindex="-1">
			<div *ngIf="item.countryCode" style="position: absolute; margin-top: 16px; margin-left: -8px">
				<i class="c-flag c-flag--{{ item.countryCode.toLowerCase() }} c-nav__thumb" aria-hidden="true"></i>
			</div>
			<div style="display:flex;flex-direction:row;flex:0; align-items: center" [ngStyle]="{'padding-left': item.countryCode ? '32px' : null}">
				<div onerror="this.style.visibility='hidden'" class="c-image c-image--bg c-image--round c-image--sm" [ngStyle]="{ 'background-image': 'url(' + item.picture + ')' }" *ngIf="vm.isValidPictureUrl(item.picture)"></div>
				<div class="c-image c-image--bg c-image--round c-image--sm" *ngIf="vm.displayPlaceHolder && !item.picture"></div>
				<span class="c-badge c-badge--inline c-badge--sm u-no-ml" *ngIf="item.isAvailable !== undefined" [ngClass]="{'c-badge--s3': item.isAvailable === true, 'c-badge--s4': item.isAvailable === false}"></span>
				<div style="margin-left:15px;margin-top:5px;flex:1;align-items:center;">
					<span>{{item.name}}</span>
					<span *ngIf="item.alias"> - {{item.alias}}</span>
					<div *ngIf="item.quantity || item.price || item.discountPrice">{{ 'Drug_Search.Available' | translate }}{{item.quantity ? item.quantity : 0}}{{item.price ? '/' + item.price : ''}}{{item.discountPrice ? '/' + item.discountPrice : ''}}</div>
					<div *ngIf="item.extra">{{item.extra}}</div>
				</div>
			</div>
		</li>
		<li class="c-autocomplete__item" *ngIf="!vm.model && !vm.items?.length && vm.term && vm.term.length >= vm.minLength && !vm.isSearching">{{ 'Common.Nothing_To_Show' | translate }}</li>
	</ul>
</div>
